// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"header-module--menu-item--3tVfD","mainHeader":"header-module--main-header--3uBk5"};